<template>
  <div class="enterprise-page">
    <EnterpriseHero />
    <EnterpriseFeatures />
    <EnterprisePricing v-model:mode="pricingMode" />
    <EnterpriseComparison v-model:mode="pricingMode" />
    <EnterpriseCases />
    <EnterpriseFaq />
    <EnterpriseCta />
  </div>
</template>

<script setup lang="ts">
import type { EnterprisePricingMode } from '~/config/enterpriseLanding'
import { useSiteConfig } from '~/config/useSiteConfig'
import EnterpriseHero from '~/components/Index/enterprise/EnterpriseHero.vue'
import EnterpriseFeatures from '~/components/Index/enterprise/EnterpriseFeatures.vue'
import EnterprisePricing from '~/components/Index/enterprise/EnterprisePricing.vue'
import EnterpriseComparison from '~/components/Index/enterprise/EnterpriseComparison.vue'
import EnterpriseCases from '~/components/Index/enterprise/EnterpriseCases.vue'
import EnterpriseFaq from '~/components/Index/enterprise/EnterpriseFaq.vue'
import EnterpriseCta from '~/components/Index/enterprise/EnterpriseCta.vue'
import useProStore from '~/store/modules/pro'
import useUserStore from '~/store/modules/user'

definePageMeta({ layout: 'enterprise' })

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const { isVipSite } = useSiteConfig()
const proStore = useProStore()
const userStore = useUserStore()
const pricingMode = ref<EnterprisePricingMode>(route.query.pricing === 'global' ? 'global' : 'local')

onMounted(() => {
  void Promise.allSettled([
    proStore.getProConfig(),
    userStore.getRoleRights(),
  ])
})

watch(pricingMode, (mode) => {
  router.replace({ query: { ...route.query, pricing: mode === 'global' ? 'global' : undefined } })
})

useHead({
  title: computed(() => t(isVipSite.value ? 'enterprise_home_seo_title_cn' : 'enterprise_home_seo_title_global')),
  meta: [
    {
      name: 'description',
      content: computed(() => t('enterprise_home_seo_description')),
    },
  ],
})

</script>

<style lang="scss">
@use './index.scss' as *;
</style>
